import { render, staticRenderFns } from "./VerifyInputs.vue?vue&type=template&id=84f61c30&"
import script from "./VerifyInputs.vue?vue&type=script&lang=js&"
export * from "./VerifyInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports